import { jobStatus } from '$variables/constants';
import formatDate from '$utils/formatDate';

const getExportJobStatus = ({ status, updatedAt, event, grades }) => {
  if (status === jobStatus.DONE) {
    return {
      message: `Export completed: ${formatDate(updatedAt)}`,
      isJobFailed: false,
      hasStudentErrors: false,
      successfulExports: grades,
      studentErrors: [],
    };
  }

  if (status === jobStatus.FAILED) {
    const studentErrors =
      (event.results && event.results.grades && event.results.grades.errors) ||
      [];

    const successfulExports =
      (event.results && event.results.grades && event.results.grades.success) ||
      [];

    const hasStudentErrors = !!studentErrors.length;

    const message = hasStudentErrors
      ? `Export completed with errors: ${formatDate(updatedAt)}`
      : `Export failed: ${formatDate(updatedAt)}`;

    return {
      message,
      isJobFailed: true,
      hasStudentErrors,
      successfulExports,
      studentErrors,
    };
  }

  return {
    message: '',
    isJobFailed: false,
    hasStudentErrors: false,
    successfulExports: [],
    studentErrors: [],
  };
};

export default getExportJobStatus;
